var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    container: {
        position: 'relative',
        display: 'inline-block',
        zIndex: 1000,
    },
    toggleButton: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '4px 10px',
        fontSize: '13px',
        fontWeight: 600,
        color: '#0063B1',
        lineHeight: '30px',
    },
    toggleButtonOpen: {
        backgroundColor: '#EDEBE9',
    },
    icon: {
        fontSize: '14px',
        color: '#0063B1',
        position: 'relative',
        top: '1px',
    },
    label: {
        color: '#0063B1',
    },
    dropdown: {
        position: 'fixed',
        backgroundColor: '#EDEBE9',
        padding: '10px',
        minWidth: '200px',
        maxHeight: '250px',
        overflowY: 'auto',
        zIndex: 10050,
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    },
    list: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
    },
    listItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 0',
        fontSize: '13px',
        color: '#323130',
    },
    colorBox: {
        display: 'inline-block',
        width: '12px',
        height: '15px',
        textAlign: 'center',
        flexShrink: 0,
    },
    legendText: {
        whiteSpace: 'nowrap',
    },
};
export default styles;
//# sourceMappingURL=EventLegend.styles.js.map